import ZoneIconHover from './component'

export default ZoneIconHover
